import { Geofence } from './Geo/Geofence'
import { PathDirection } from '@iotv/iotv-v3-types'
import { GeoModelCommon } from './Geo/GeoModelCommon'
import { UserAttributeDef, UserAttributeDefs } from '../types/ModelTypes'

const typeName = 'Property'

export type PropertyProps = {
  // iD?: unknown,
  name?: string
  // address?: unknown,
  type: string
}

class Property extends GeoModelCommon {
  constructor(ob: Partial<PropertyProps>) {
    super({ ...ob, type: ob.type || typeName })
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      // iD: { type: 'UNKNOWN', editable: true, label: 'ID', name: 'iD' },
      // name: { type: 'UNKNOWN', editable: true, label: 'Name', name: 'name' },
      // address: { type: 'UNKNOWN', editable: true, label: 'Address', name: 'address' },
      name: {
        type: 'String',
        editable: true,
        label: 'Property Name',
        name: 'name',
        description: 'identification',
        validation: { regex: /^[\p{L}0-9\s']+$/u, pass: true, invalidMessage: 'Name cannot contain invalid characters' },
      },
      description: { type: 'String', editable: true, label: 'Description', description: 'description' },
      dwellingNumber: { type: 'String', editable: true, label: 'Dwelling Number', description: 'Dwelling Number' },
      streetName: { type: 'String', editable: true, label: 'Street Number & Name', description: 'street name' },
      suburb: { type: 'String', editable: true, label: 'Suburb' },
      city: { type: 'String', editable: true, label: 'City' },
      country: { type: 'String', editable: true, label: 'Country' },
      postcode: { type: 'String', editable: true, label: 'Postcode' },
      // Field: { type: 'RelatedType', editable: false, label: 'Fields', name: 'Fields', direction: PathDirection.child, edgeTypeId: 'Property_has_Fields_Field' },
      // Horse: { type: 'RelatedType', editable: false, label: 'Horses', name: 'Horse', direction: PathDirection.child, edgeTypeId: 'Property_has_HorsesHorse' },
    }
  }
}

export { Property }
